import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

export interface time {
   hours: number
   minutes: number
}
@Component({
    selector: 'time-input',
    templateUrl: './time-input.component.html',
    styleUrls: ['./time-input.component.scss'],
    standalone: false
})
export class TimeInputComponent implements OnInit{
  @Input() defaultTime:time={
    hours:0,
    minutes:0
  }
  @Output() onUpdateTime = new EventEmitter<time>()
  timeForm!: FormControl<string|null>
  constructor(private readonly cdr: ChangeDetectorRef,){
  }
  ngOnInit(): void {  
    this.timeForm = new FormControl(`${String(this.defaultTime.hours).padStart(2, '0')}:${String(this.defaultTime.minutes).padStart(2, '0')}`);    
    this.timeForm.valueChanges.subscribe((value)=>{
      if(!value) return
      var s=value?.split(":")!;
      if(s.length!=2) return
      this.onUpdateTime.emit({hours:Number(s[0]),minutes:Number(s[1])})
    })
  }
}
